import pathCreator from "./path-creator";
import ConnectExterrnal from "../form-validation/connect-external";


const connectExternal = new ConnectExterrnal();

/**
 * Static class which gathers functionality related to Formbuilder "custom pages".
 * To create panels:
 * 1. add class `formbuilder_panels` to the main form
 * 2. add fieldset and set it class to `panel` in your form settings
 * 3. repeat step 2 until you have enough panels
 * Remember to also create two buttons for moving between pages outside of fieldsets (one with class `panel-button-previous` and
 * second `panel-button-next`).
 * Also, there is option to hide send button if user is not at the last page by adding `panel-button-send` to it.
 */
class FormbuilderPanels {
    static panelPreviousButtonClass = '.panel-button-previous';

    static panelNextButtonClass = '.panel-button-next';

    static panelSendButtonClass = '.panel-button-send';

    static panelClass = '.panel';

    static parentPanelClass = '.formbuilder_panels';

    static panelExpanded = '.panel_expanded';

    static visibleClass = 'visible';

    static previousPanelIndex;

    static pathCreator = pathCreator;

    static pathIndex = 0;

    constructor() {
        throw new Error('FormbuilderPanels is a static class and cannot be initialized');


    }

    /**
     * Sets up event listener when page was downloaded and
     * parsed which calls then `activatePanels` static method
     */
    static init() {
        window.addEventListener('DOMContentLoaded', (event) => {
            FormbuilderPanels.activatePanels.bind(FormbuilderPanels)();
        });
    }

    /**
     * Sets up buttons and activates first panel
     * All panels start hidden and then script shows the first one.
     * It also attaches events to buttons (previous, next) and saves all
     * essential data inside the scope of those events
     */
    static activatePanels() {
        // First search for all forms with class `formbuilder_panels` then panels inside it
        const forms = document.querySelectorAll(`form${this.parentPanelClass}`);


        forms.forEach((form) => {
            const panels = form.querySelectorAll(this.panelClass);
            if (panels.length == 0) {
                return;
            }
            const panelsExpanded = form.querySelectorAll(this.panelExpanded);

            if(panelsExpanded.length>0){this.panelsSort='expanded'}else{this.panelsSort='simple';}
            // Set first panel visible
            this.activatePanel(panels, 0);
            // Find all buttons
            const previousButton = form.querySelector(this.panelPreviousButtonClass);
            const nextButton = form.querySelector(this.panelNextButtonClass);
            const sendButton = form.querySelector(this.panelSendButtonClass);
            if (!previousButton || !nextButton) {
                console.error(
                    `Form Builder panels are required to have previous and next buttons with classes set to ${
                        this.panelPreviousButtonClass} and ${this.panelNextButtonClass}`,
                );
                return;
            }
            // Show next button (all buttons are invisible at start)
            nextButton.classList.add(this.visibleClass);
            // Set which panel is active
            form.activePanelIndex = 0;
            const essentials = {
                form, panels, previousButton, nextButton, sendButton,
            };
            previousButton.addEventListener('click', this.activatePreviousPanel.bind(Object.assign(this, essentials)));
            nextButton.addEventListener('click', this.activateNextPanel.bind(Object.assign(this, essentials)));
            if(form.querySelectorAll('.glide__arrow')){
                let nextPrev = form.querySelectorAll('.glide__arrow');
                let thisThis = this;

                nextPrev.forEach((button, index) => {
                    button.addEventListener('click', function() {
                        let listPanelsCopy = thisThis.createList('.glide__arrow');

                        listPanelsCopy.forEach((elem) => {
                            if (elem.classList.contains('active')) {
                                elem.classList.remove('active');
                                thisThis.activatePreviousPanel(thisThis);
                            }
                        });
                        listPanelsCopy.forEach((elem) => {
                            if (elem.classList.contains('active')) {
                                elem.classList.remove('active');
                                thisThis.activatePreviousPanel(thisThis);
                            }
                        });
                    });
                });

            }
        });
    }
    static createList(selector){
        let listFormGroup = Array.from(this.panels);
        let listFormGroupCopy = Array.from(this.panels);
        let foundSlideGlideNextPrev = false;
        listFormGroupCopy.forEach((elemDiv) => {
            if (foundSlideGlideNextPrev === false) {
                if (elemDiv.querySelector(selector)) {
                    foundSlideGlideNextPrev = true;
                }
                let indexToRemove = listFormGroup.indexOf(elemDiv);
                if (indexToRemove !== -1) {
                    listFormGroup.splice(indexToRemove, 1);
                }

            }
        });
        return listFormGroup;
    }

    /**
     * Turns previous panel visible (if there is one).
     * Hides `send` button and (if needed) `previous` button. Will always show `next` button.
     * @param {Event} e On click event
     */
    static activatePreviousPanel(e) {
        // Check if there is another panel to show
        if (this.form.activePanelIndex <= 0) {
            return;
        }

        this.deactivatePanel(this.panels, this.form.activePanelIndex);
        this.previousPanelIndex = this.form.activePanelIndex;

        // Get the previous panel index from path
        if (this.pathIndex > 0) this.form.activePanelIndex = this.pathCreator.getPath()[--this.pathIndex] - 1;
        else {
            // If there is no path, return to the previous panel (previous = one index before)
            this.form.activePanelIndex--;
            // Clear the path
            this.pathCreator.setPath([]);
        }
        this.activatePanel(this.panels, this.form.activePanelIndex);
        if (this.form.activePanelIndex <= 0) {
            this.previousButton.classList.remove(this.visibleClass);
        }
        this.sendButton?.classList.remove(this.visibleClass);
        this.nextButton.classList.add(this.visibleClass);


    }

    /**
     * Shows next panel (if exists).
     * Turns visible `send` button if it's last panel (or last in path).
     * Makes `next` button invisible if it's the last panel.
     * Makes `previous` button visible.
     * @param {Event} e On click event
     */
    static activateNextPanel(e) {
        // Check if there is another panel to show and if the panel is correct

        const panel = this.panels[this.form.activePanelIndex];

        if(panel.classList.contains('send-sms')){

            //connectExternal.smsCreate(this.form);
            connectExternal.sendAuthorizedSMS(this.form)
        }
        if (this.panels.length - 1 <= this.form.activePanelIndex || panel.classList.contains('incorrect')) {
            return;
        }

        this.deactivatePanel(this.panels, this.form.activePanelIndex);
        this.previousPanelIndex = this.form.activePanelIndex;

        // If path exists, set active panel index to the next index from path
        if (pathCreator.getPath() && pathCreator.getPath().length > 0)
            this.form.activePanelIndex = pathCreator.getPath()[++this.pathIndex] - 1;
        else this.form.activePanelIndex++;

        this.activatePanel(this.panels, this.form.activePanelIndex);
        // Check if active panel is the last panel
        // Check if active panel is the last panel in path
        if (this.panels.length - 1 <= this.form.activePanelIndex ||
            this.form.activePanelIndex === (this.pathCreator.getPath() ? this.pathCreator.getPath()[this.pathCreator.getPath().length - 1] - 1 : -1)) {
            this.nextButton.classList.remove(this.visibleClass);
            this.sendButton?.classList.add(this.visibleClass);
        }
        this.previousButton.classList.add(this.visibleClass);
    }

    static scrollWithTopOffset(element, topRatio = 0.3){
        const elementRect = element.getBoundingClientRect();
        const scrollTop = window.scrollY;
        const targetY =
          elementRect.top + scrollTop - window.innerHeight * topRatio;
      
        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
    }

    static activatePanel(panels, index) {
        panels[index].classList.add('active');
        if (this.panelsSort !== 'simple') {
                this.scrollWithTopOffset(panels[index]);
                // window.scrollBy(0, 350);
        }
        // Dispatch a custom event to indicate that a panel has been changed
        const event = new CustomEvent('panelChanged', {
            detail: {
                form: this.form,
                panels: panels,
                previousPanelIndex: this.previousPanelIndex,
                newPanelIndex: index,
            }
        });

        document.dispatchEvent(event);
    }

    static deactivatePanel(panels, index) {

        if (this.form.hasAttributes()) {

            if(this.panelsSort==='simple'){
                panels[index].classList.remove('active');
            }

        }
    }
}

// Search for formbuilder panels
FormbuilderPanels.init();